export const budgetEstimatorMapping = {
  'Full Estimate': 'data',
  'DOW Summary': 'dowSummary',
  'Grand Summary': 'grandSummary',
  'Scope of Work': 'scopeSummary'
}
